import React, { useRef } from "react";
import { RelationTypeItem } from "./RelationTypeItem";
import { getCountryByCode } from "../../../../../utils/Helper";
import { Link, useNavigate } from 'react-router-dom';
import { toSentenceCase } from "../../../../../global_functions/global";
import { Button, Card } from "../../../../common";
import useScreenSize from "../../../../../Hooks/useScreenSize";

export const RelatedEntities = ({ relatedEntity }) => {
  const { isMobile, isTablet, isDesktop } = useScreenSize();
  const containerCarousel = useRef(null);
  const navigate = useNavigate();

  const btnPressPrev = () => {
    if (containerCarousel.current) {
      const containerWidth = containerCarousel.current.offsetWidth;
      containerCarousel.current.scrollLeft -= containerWidth;
    }
  };

  const btnPressNext = () => {
    if (containerCarousel.current) {
      const containerWidth = containerCarousel.current.offsetWidth;
      containerCarousel.current.scrollLeft += containerWidth;
    }
  };

  const navigateToPage = (id) =>{
    window.open(`/search/${id}`, '_blank');
  }
  
  return (
    <Card classes="rounded-xl bg-white p-6 mb-6">
      <div>
        {" "}
        <h3 className="text-secondarytwo text-left text-[18px] sm:text-f18 font-semibold">
          Related Entities
        </h3>
      </div>
      <div className="rounded-xl sm:grid grid-cols-3 gap-4 containerCarousel p-2 flex overflow-x-hidden scroll-smooth" ref={containerCarousel}>
        {relatedEntity.map((relatedEntity) => (
          relatedEntity?.related_entityID?.companyWIN ?
            <div className="w-full min-w-[100%]" onClick={relatedEntity?.related_entityID?.companyWIN ? ()=>navigateToPage(relatedEntity?.related_entityID?.companyWIN) : null}>
              <RelationTypeItem
                name={
                  relatedEntity?.related_entityID?.companyName
                }
                country={relatedEntity?.related_entityID?.state != null ? `${relatedEntity?.related_entityID?.state}, ${getCountryByCode(relatedEntity?.related_entityID?.country)}` : `${getCountryByCode(relatedEntity?.related_entityID?.country)}`}
                type={"Relation Type"}
                typeValue={relatedEntity?.related_entityID?.relation_type}
                companyID={relatedEntity?.related_entityID?.companyID?.companyID}
              />
            </div> :
            <div className="w-full min-w-[100%]" onClick={relatedEntity?.related_entityID?.companyID?.companyID ? ()=>navigateToPage(relatedEntity?.related_entityID?.companyID?.companyID) : null} target="_blank">
              <RelationTypeItem
                name={
                  relatedEntity?.related_entityID?.companyID
                    ?.registered_company_name || relatedEntity?.related_entityID?.companyName
                }
                country={`${relatedEntity?.related_entityID?.state}, ${getCountryByCode(relatedEntity?.related_entityID?.country)}`}
                type={"Relation Type"}
                typeValue={relatedEntity?.related_entityID?.relation_type}
                companyID={relatedEntity?.related_entityID?.companyID?.companyID}
              />
            </div>
        ))}
      </div>
      {isMobile && <div className="carousel_box relative overflow-hidden p-4">
        <button className="pre-btn rotate-180" onClick={btnPressPrev}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
          >
            <path
              d="M3.33301 10.5H16.6663M16.6663 10.5L11.6663 5.5M16.6663 10.5L11.6663 15.5"
              stroke="#2C5369"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <button className="next-btn" onClick={btnPressNext}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
          >
            <path
              d="M3.33301 10.5H16.6663M16.6663 10.5L11.6663 5.5M16.6663 10.5L11.6663 15.5"
              stroke="#2C5369"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>}
    </Card>
  );
};
